import axios from 'axios';
import api from '../constants/constants';
import sha1 from 'sha1'

var date = new Date();

var iso = date.getTime();


const generateSecurityToken = (url) => {
   
    let newUrl = url;
    var secret = '#a2@innovationm.com$';
   
    return sha1(`${newUrl}${iso}1${secret}`)
}

 const userToken = localStorage.getItem('userToken')
export function loginRequest(apiUrl,data){
    const url = api.apiIpPort + api.apiBaseUrl+apiUrl
    const sha = generateSecurityToken(api.apiBaseUrl + apiUrl);
    // console.log(api.apiBaseUrl + apiUrl+"= "+sha+"= "+iso)
    const header = {
        "AppAuthenticationToken":sha,
        "timestamp":iso,
        "Access-Control-Allow-Headers": "*",
    //    "Access-Control-Allow-Origin": "https://foxmatrix.com",
    }
    return axios({
        method:"post",
        url:url,
        data:data,
        headers:header,
    })
}

export function postRequest(apiUrl,data){
    const url = api.apiIpPort + api.apiBaseUrl+apiUrl
    const sha = generateSecurityToken(api.apiBaseUrl + apiUrl);
    // console.log(api.apiBaseUrl + apiUrl+"= "+sha+"= "+iso)
    const header = {
        "Authorization":localStorage.getItem('userToken'),
        "AppAuthenticationToken":sha,
        "timestamp":iso,
        "Access-Control-Allow-Headers": "*",
    //    "Access-Control-Allow-Origin": "https://foxmatrix.com",
    }
    return axios({
        method:"post",
        url:url,
        data:data,
        headers:header
    })
}

export function postRequestFile(apiUrl,data){
    const url = api.apiIpPort + api.apiBaseUrl+apiUrl
    const sha = generateSecurityToken(api.apiBaseUrl + apiUrl);
    // console.log(api.apiBaseUrl + apiUrl+"= "+sha+"= "+iso)
    const header = {
            "Authorization": localStorage.getItem('userToken'),
            "AppAuthenticationToken":sha,
            "content-Type":  undefined,
            "timestamp":iso,
            "Access-Control-Allow-Headers": "*",
        //    "Access-Control-Allow-Origin": "https://foxmatrix.com",
    }
    return axios({
        method:"post",
        url:url,
        data:data,
        headers:header
    })
}

export function postResetPass(apiUrl,data,token){
    const url = api.apiIpPort + api.apiBaseUrl+apiUrl
    const sha = generateSecurityToken(api.apiBaseUrl + apiUrl);
    // console.log(api.apiBaseUrl + apiUrl+"= "+sha+"= "+iso)
    const header = {
        "token":token,
        'content-Type': 'application/json',
        "AppAuthenticationToken":sha,
        "timestamp":iso,
        "Access-Control-Allow-Headers": "*",
    //    "Access-Control-Allow-Origin": "https://foxmatrix.com",
    }
    return axios({
        method:"post",
        url:url,
        data:data,
        headers:header
    })
}

export  function getRequest(apiUrl){
    
    const url = api.apiIpPort + api.apiBaseUrl + apiUrl ;
   
    const sha = generateSecurityToken(api.apiBaseUrl + apiUrl);
    // console.log(api.apiBaseUrl + apiUrl+"= "+sha+"= "+iso)
    const header ={
        "Authorization":localStorage.getItem('userToken'),
        "AppAuthenticationToken":sha,
        "timestamp":iso,
        "Access-Control-Allow-Headers": "*",
    //    "Access-Control-Allow-Origin": "https://foxmatrix.com",
    }

    return axios({
        method:'get',
        url:url,
        headers:header
    })
}


export function putRequest(apiUrl, data){
    const url = api.apiIpPort + api.apiBaseUrl + apiUrl ;
    const sha = generateSecurityToken(api.apiBaseUrl + apiUrl);
    // console.log(api.apiBaseUrl + apiUrl+"= "+sha+"= "+iso)
    const header ={
        "Authorization": localStorage.getItem('userToken'),
        "AppAuthenticationToken":sha,
        "timestamp":iso,
        "Access-Control-Allow-Headers": "*",
    //    "Access-Control-Allow-Origin": "https://foxmatrix.com",
    }
    return axios({
        method:'put',
        data: data,
        url:url,
        headers:header
    })
}

export function postRequestVerify(apiUrl,data){
    const url = api.apiIpPort + api.apiBaseUrl + apiUrl ;
    const sha = generateSecurityToken(api.apiBaseUrl + apiUrl);
    // console.log(api.apiBaseUrl + apiUrl+"= "+sha+"= "+iso)
    const header ={
        "Authorization": localStorage.getItem('userToken'),
        "AppAuthenticationToken":sha,
        "timestamp":iso,
        "Access-Control-Allow-Headers": "*",
    //    "Access-Control-Allow-Origin": "https://foxmatrix.com",
     }
    return axios({
        method:"post",
        url:url,
        data:data,
        headers:header
    })
}